import { render } from "./ModalConfirmAlert.vue?vue&type=template&id=aec1f5c2"
import script from "./ModalConfirmAlert.vue?vue&type=script&lang=js"
export * from "./ModalConfirmAlert.vue?vue&type=script&lang=js"

import exportComponent from "/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__